import React, { useMemo } from 'react';

import { useReactNativeProps, runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib';

import { SearchParams, useSearchParam } from '@/domain/app';

import { ApplePayKbQuery, ApplePayTeQuery } from './Query';

export const ApplePay = () => {
    const nativeProps = useReactNativeProps();
    const ctype = useSearchParam(SearchParams.CARD_TYPE);

    const enabled = useMemo(() => runningInRNWebView && Boolean(nativeProps.supports?.applePay), [nativeProps]);

    if (!enabled) {
        return false;
    }

    if (ctype === 'CREDIT') {
        return <ApplePayKbQuery />;
    }

    return <ApplePayTeQuery />;
};
